import * as React from "react";
import { SVGAttributes } from "react";

export const WkIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          fill="#9B53C8"
          d="M25.133 10.7c-.482-.608-.344-.879 0-1.422.006-.006 3.979-5.496 4.388-7.357l.002-.002c.204-.678 0-1.177-.983-1.177h-3.255c-.828 0-1.21.428-1.415.907 0 0-1.657 3.966-4.001 6.538-.757.743-1.107.98-1.52.98-.203 0-.52-.237-.52-.916V1.92c0-.813-.231-1.177-.917-1.177h-5.118c-.52 0-.828.38-.828.733 0 .772 1.172.95 1.293 3.12v4.71c0 1.031-.187 1.22-.602 1.22-1.107 0-3.792-3.982-5.383-8.54-.322-.884-.635-1.242-1.47-1.242H1.548c-.93 0-1.116.428-1.116.907 0 .846 1.106 5.052 5.145 10.609 2.691 3.793 6.482 5.848 9.93 5.848 2.072 0 2.325-.457 2.325-1.242 0-3.624-.187-3.966.851-3.966.481 0 1.31.238 3.245 2.067 2.211 2.17 2.575 3.14 3.813 3.14h3.254c.928 0 1.398-.456 1.128-1.356-.62-1.894-4.802-5.79-4.99-6.05z"
        />
      </svg>
    );
  }
);
